// extracted by mini-css-extract-plugin
export var details = "_f4-0";
export var inspectorPopover = "_f4-1";